import React from 'react';
import { PartnerReviewPage } from '../components/PartnerReviewPage';
import type { PartnerReviewConfig } from '../models/partnerReview';

const DEMOTION_CONFIG: PartnerReviewConfig = {
  fetchEndpoint: '/TierChange/demotionEligible',
  submitEndpoint: '/TierChange/submitDemotions',
  requestItemsKey: 'demotions',
  tierChangeLabel: 'Demoted to',
  candidateLabel: 'Demotion candidates',
  nextTierFilterLabel: 'Demoted to',
  exportFileName: 'FiscalEndReview',
  pageTitle: 'Fiscal year end review',
  pageSubtitle: 'Review and approve/deny partner demotions. Revenue finalized in May; demotions appear July 1st.',
};

export const FiscalEndReviewPage: React.FC = () => <PartnerReviewPage config={DEMOTION_CONFIG} />;
